window.paymentForm = {

    iCountTime: 0,
    oTime: null,
    isEditingAFailedColaboration: false,
    gatewayPaymentType: null,
    isPaying: false,
    hasAdditionalTerms: false,
    init: (gatewayPaymentType) => {
        $('[name="cc_is_national"]').bootstrapSwitch({
            state: true,
            onColor: 'pink',
            //onText: $(this).data('onText') ? $(this).data('onText') : 'SIM',
            //offText: $(this).data('offText') ? $(this).data('offText') : 'NÃO',
        });

        // self.cardValidator = cardValidator.creditCardType.addCard({
        //     niceType: 'Aura',
        //     type: 'aura',
        //     patterns: [50],
        //     gaps: [4, 8, 12],
        //     lengths: [16],
        //     code: {
        //         name: 'CVV',
        //         size: 3
        //     }
        // });

        paymentForm.oTime = null;
        paymentForm.iCountTime = 30;
        paymentForm.gatewayPaymentType = gatewayPaymentType;
        paymentForm.bind.cc();
        paymentForm.bind.payment.ticket();
        paymentForm.bind.payment.cc();

        $('[title!=""]').qtip({
            style: {classes: 'qtip-core'}
        });
    },
    bind: {
        cc: () => {

            App.bindEvent('ccNumber', 'input', function (e) {
                this.value = this.value.replace(/[^0-9]/g, '');
                $('#cc_number_validation_msg').hide();
            });

            App.bindEvent('ccNumber', 'blur', function (e) {
                paymentForm.validation.methods.cc.number(e.currentTarget.value);
            });

            App.bindEvent('ccNumber', 'cut copy paste', function (e) {
                e.preventDefault();
            });

            App.bindEvent('ccExpirationMonth', 'change', function (e) {
                $('#cc_expiration_date_validation_msg').hide();
            });

            App.bindEvent('ccExpirationYear', 'change', function (e) {
                $('#cc_expiration_date_validation_msg').hide();
            });

            // App.bindEvent('ccCvv', 'change', function(e) {
            //     paymentForm.validation.methods.cc.code(e.currentTarget.value);
            // });

            // App.bindEvent('ccCvv', 'keyup', function(e) {
            //     paymentForm.validation.methods.cc.code(e.currentTarget.value);
            // });

            App.bindEvent('ccName', 'input', function (e) {
                this.value = this.value.replace(/[^a-zA-Z\s]/g, '');
                $('#cc_name_validation_msg').hide();
            });

            App.bindEvent('ccCvv', 'keypress', function (e) {
                if (e.currentTarget.value.length === paymentForm.validation.rules.cc.codeSize) {
                    e.preventDefault();
                }
            });

            App.bindEvent('ccCvv', 'input', function (e) {
                this.value = this.value.replace(/[^0-9]/g, '');
                $('#cc_code_validation_msg').hide();
            });

        },
        payment: {
            ticket: () => {
                $('#btnPagarBoleto').unbind('click');
                App.bindEvent('GoPaymentGatewayBoleto', 'click', function (ev) {
                    ev.preventDefault();
                    const paymentOption = 'BoletoBancario';
                    paymentForm.validatePaymentOption(
                        paymentOption,
                        paymentForm.validation.callback
                    );
                });
            },
            cc: () => {
                $('#btnPagar').unbind('click');
                App.bindEvent('GoPaymentGatewayCC', 'click', function (ev) {
                    ev.preventDefault();
                    const paymentOption = 'CartaoCredito';
                    paymentForm.validatePaymentOption(
                        paymentOption,
                        paymentForm.validation.callback
                    );
                });
            }
        }
    },
    validation: {
        callback: (paymentOption, m = null) => {

            const errorMsg = $('#divMensagemErro');
            const btnBack = $('#btnVoltar');
            const btnPayCc = $('#btnPagar');
            const btnPayTicket = $('#btnPagarBoleto');

            if (m) {
                errorMsg.html(m);
            }
            errorMsg.hide();
            $('#divMensagemAviso').hide();
            $('#countdown').html('30s');
            $('#divMensagemInfo').show();
            paymentForm.startCountdown();

            // Desabilita os botões de voltar e submeter
            btnBack.attr('disabled', 'disabled');
            btnBack.prop('disabled', true);
            btnPayCc.attr('disabled', 'disabled');
            btnPayCc.prop('disabled', true);
            btnPayCc.unbind('click');
            btnPayTicket.attr('disabled', 'disabled');
            btnPayTicket.prop('disabled', true);

            // Esconde as opções de pagamento
            $('.panel-payment').hide();

            // Submete as informações de pagamento
            paymentForm.ajaxMagic(paymentOption);
        },
        functions: {
            inputs: {
                invalidate: () => {
                    paymentForm.validation.status.cc = {
                        number: false,
                        name: false,
                        expirationMonth: false,
                        expirationYear: false,
                        code: false
                    };
                }
            }
        },
        inputs: {
            security: {
                csrf: () => ($('#csrf'))
            },
            cc: {
                number: () => { return $('#cc_numero') },
                name: () => { return $('#cc_nome_impresso') },
                expirationMonth: () => { return $('#cc_expiration_month') },
                expirationYear: () => { return $('#cc_expiration_year')},
                code: () => { return $('#cc_codigo_seguranca')},
                national: () => { return $('#cc_is_national')}
            },
            user: {
                birthday: () => { return $('#udata')},
                phone: () => { return $('#uphone')},
                code: () => {return $('#uidentify')},
            }
        },
        status: {
            cc: {
                number: false,
                name: false,
                expirationMonth: false,
                expirationYear: false,
                code: false
            }
        },
        rules: {
            cc: {
                supportedFlags: [
                    'visa',
                    'mastercard',
                    'american-express',
                    'diners-club',
                    'discover',
                    'elo',
                    'hipercard',
                    'aura'
                ],
                codeSize: 4
            }
        },
        methods: {
            cc: {
                number: function (number) {

                    paymentForm.validation.status.cc.number = false;

                    const input = $('#cc_numero');
                    const inputValidClass = 'is-valid';
                    const inputInvalidClass = 'is-invalid';
                    input.addClass(inputInvalidClass);

                    const alert = $('#cc_number_validation_msg');
                    alert.hide();

                    if (number === '') {
                        alert.show();
                        return;
                    }

                    // const numberLength = number.length;

                    // if (numberLength < 3) {
                    //     alert.html('Insira os 3 primeiros digitos.');
                    //     alert.show();
                    //     return;
                    // }

                    const cardValidator = self.cardValidator;
                    const validation = cardValidator.number(number);

                    // console.log('cc number validation', validation);

                    if (validation.isPotentiallyValid === false || validation.card === null) {

                        alert.html('O número do seu cartão de crédito é inválido.');
                        alert.show();
                        return;

                    }

                    paymentForm.validation.rules.cc.codeSize = validation.card.code.size;

                    if (!paymentForm.validation.rules.cc.supportedFlags.includes(validation.card.type)) {

                        alert.html('Esta bandeira não é suportada.');
                        alert.show();
                        return;

                    }

                    // if (!validation.card.lengths.includes(numberLength)) {
                    //
                    //     alert.html('Informe a quantidade de digitos correta.');
                    //     alert.show();
                    //     return;
                    //
                    // }

                    if (validation.isPotentiallyValid === true && validation.isValid !== true) {

                        const cardNiceType = typeof (validation.card.niceType) !== "undefined" ? validation.card.niceType : 'cartão';
                        alert.html(`Hm...<br>O número do seu ${cardNiceType} é inválido...<br>Certifique-se que o número foi inserido corretamente.`);
                        alert.show();
                        return;

                    }

                    paymentForm.validation.status.cc.number = true;
                    input.addClass(inputValidClass);

                },
                name: function (v) {

                    paymentForm.validation.status.cc.name = false;

                    const alert = $('#cc_name_validation_msg');
                    alert.hide();

                    if (typeof (v) === 'undefined' || v.length <= 5) {
                        alert.show();
                        return;
                    }

                    paymentForm.validation.status.cc.name = true;

                },
                expirationMonth: function (v) {

                    paymentForm.validation.status.cc.expirationMonth = false;

                    let alert = $('#cc_expiration_date_validation_msg');
                    alert.hide();

                    const validation = self.cardValidator.expirationMonth(v);

                    // console.log('cc expiration month validation', validation);

                    if (validation.isValid === false) {
                        alert.show();
                        return;
                    }

                    const expirationYear = parseInt(paymentForm.validation.inputs.cc.expirationYear().children('option:selected').val());
                    const currentYear = new Date().getFullYear();

                    if (validation.isValidForThisYear === false
                        &&
                        expirationYear.toString() === currentYear.toString().substr(2)) {
                        alert.show();
                        return;
                    }

                    paymentForm.validation.status.cc.expirationMonth = true;

                },
                expirationYear: function (v) {

                    paymentForm.validation.status.cc.expirationYear = false;

                    const alert = $('#cc_expiration_validation_msg');
                    alert.hide();

                    const validation = self.cardValidator.expirationYear(v);

                    // console.log('cc expiration year validation', validation);

                    if (validation.isValid === false) {
                        alert.show();
                        return;
                    }

                    paymentForm.validation.status.cc.expirationYear = true;

                },
                code: function (v) {

                    paymentForm.validation.status.cc.code = false;

                    const alert = $('#cc_code_validation_msg');
                    alert.hide();

                    if (typeof (v) === 'undefined') {
                        alert.show();
                        return;
                    }

                    const cardValidator = self.cardValidator;
                    const validation = cardValidator.cvv(v, paymentForm.validation.rules.cc.codeSize);

                    // console.log('cc cvv validation', validation);

                    if (validation.isValid !== true) {
                        alert.show();
                        return;
                    }

                    paymentForm.validation.status.cc.code = true;

                },
            }
        }
    },

    startCountdown: function () {
        paymentForm.iCountTime = 30;
        paymentForm.oTime = setTimeout('paymentForm.decreaseTime()', 1000);
    },

    decreaseTime: function () {
        paymentForm.iCountTime = paymentForm.iCountTime - 1;
        $('#countdown').html(paymentForm.iCountTime + 's');
        setTimeout('paymentForm.decreaseTime()', 1000);
    },

    validatePaymentOption: function (paymentOption, callback) {

        $('.panel-paypal').hide();

        let message;
        let proceed = false;

        paymentForm.validation.functions.inputs.invalidate();

        switch (paymentOption) {

            case 'CartaoCredito':

                paymentForm.validation.methods.cc.number(paymentForm.validation.inputs.cc.number().val());
                paymentForm.validation.methods.cc.name(paymentForm.validation.inputs.cc.name().val());
                paymentForm.validation.methods.cc.expirationMonth(paymentForm.validation.inputs.cc.expirationMonth().children('option:selected').val());
                paymentForm.validation.methods.cc.expirationYear(paymentForm.validation.inputs.cc.expirationYear().children('option:selected').val());
                paymentForm.validation.methods.cc.code(paymentForm.validation.inputs.cc.code().val());

                if (paymentForm.validation.status.cc.number === true
                    &&
                    paymentForm.validation.status.cc.name === true
                    &&
                    paymentForm.validation.status.cc.expirationMonth === true
                    &&
                    paymentForm.validation.status.cc.expirationYear === true
                    &&
                    paymentForm.validation.status.cc.code === true
                ) {
                    if (window.paymentForm.hasAdditionalTerms) {
                        if ($.find("input[id='additionalTermsCheckCc']:checked").length > 0) {
                            proceed = true;
                        } else {
                            console.log('falhou');
                            $('#validateAdditionalTermsCc').show();
                        }
                    } else {
                        proceed = true;
                    }
                }
                break;

            case 'BoletoBancario':
                message = '<strong>Ops... Ocorreu um problema e não conseguimos completar sua contribuição.</strong>';
                if (window.paymentForm.hasAdditionalTerms) {
                    if ($.find("input[id='additionalTermsCheckTicket']:checked").length > 0) {
                        proceed = true;
                    } else {
                        console.log('falhou');
                        $('#validateAdditionalTermsTicket').show();
                    }
                } else {
                    proceed = true;
                }
                break;

        }

        if (proceed === true && paymentForm.isPaying === false) {
            paymentForm.isPaying = true;
            callback(paymentOption, message);
        } else {
            $('html, body').animate({
                scrollTop: $("#formGateway").offset().top - 120
            }, 2000);
        }

    },

    ajaxMagic: function (paymentOption, isPagarme = true) {

        if (paymentForm.gatewayPaymentType !== 2) {
            isPagarme = false;
        }
        const csrf = paymentForm.validation.inputs.security.csrf().val();

        const ccNumber = paymentForm.validation.inputs.cc.number().val();
        const ccName = paymentForm.validation.inputs.cc.name().val();

        const ccExpirationMonth = paymentForm.validation.inputs.cc.expirationMonth().children('option:selected').val();
        const ccExpirationYear = paymentForm.validation.inputs.cc.expirationYear().children('option:selected').val();
        const ccExpirationDate = `${ccExpirationMonth}/${ccExpirationYear}`;

        const ccCode = paymentForm.validation.inputs.cc.code().val();
        const ccInternational = !paymentForm.validation.inputs.cc.national().is(":checked");

        const uBirthday = paymentForm.validation.inputs.user.birthday().data('nascimento');
        const uPhone = paymentForm.validation.inputs.user.phone().data('phone');
        const uCode = paymentForm.validation.inputs.user.code().data('identify');

        let parcelas = $('#parcelas-select-field').val();
        parcelas = parcelas ? parcelas : 1;

        const data = {
            csrf: csrf,
            contributionId: ProjectPage.contribution_id,
            projectId: ProjectPage.project_id,
            type: paymentOption,
            cc_number: ccNumber,
            cc_holder_name: ccName,
            cc_expiration_date: ccExpirationDate,
            cc_security_number: ccCode,
            cc_international: ccInternational,
            cc_installments: parcelas
        };

        // console.log('data', data);

        $.ajax({
            type: 'POST',
            url: App.webRoot + 'projeto/ajaxGatewayPagamento',
            data: data,
            dataType: 'json',
            cache: false,
            timeout: 40000,
            success: function (json) {

                $('#divLoadingEmail').hide();
                clearTimeout(paymentForm.oTime);
                if (!isPagarme) {
                    if (json.status.toLowerCase() === 'sucesso') {
                        // processa o checkout transparente
                        const settings = {
                            "Forma": paymentOption,
                            "Parcelas": "1",
                            "CartaoCredito": {
                                "Numero": ccNumber,
                                "Expiracao": ccExpirationDate,
                                "CodigoSeguranca": ccCode,
                                "Portador": {
                                    "Nome": ccName,
                                    "DataNascimento": uBirthday,
                                    "Telefone": uPhone,
                                    "Identidade": uCode,
                                }
                            }
                        };

                        $('#MoipWidget').attr('data-token', json.token);
                        MoipWidget(settings);
                    } else {
                        // não recebeu um json
                        let msg = $('#divMensagemErro');
                        msg.html('Ocorreu um problema na autorização de sua contribuição. <br/><br><b>' + json.erro[0] + '</b><br><br> Por favor, tente novamente.');
                        $('#divMensagemAviso').hide();
                        $('#divMensagemInfo').hide();
                        msg.show();
                        $('#btnVoltar').prop('disabled', false);
                        $('#btnPagar').prop('disabled', false);
                    }
                } else {
                    //we are using Pagarme (payment based on api) here

                    if (json.status && json.status.toLowerCase() === 'sucesso') {
                        let status = json.payment_status;
                        const transaction_refuse_reason = json.transaction_refuse_reason;
                        const transaction_status_reason = json.transaction_status_reason;
                        Utils.goToSidebarTop();

                        let url = App.webRoot + 'projeto/ajaxContribuicaoPagarme/'
                            + ProjectPage.project_id + '-'
                            + ProjectPage.contribution_id + '-'
                            + status.normalize();

                        if (transaction_refuse_reason) {
                            url += '-'
                                + transaction_refuse_reason.normalize() + '-'
                                + transaction_status_reason.normalize();
                        }

                        App.loadContentViaAjax(url, {}, '.panel-sidebar .panel-body');
                    } else if(json.status && json.status.toLowerCase() === 'fail') {
                        let errorMessage = json.error_msg;

                        let target = $('.panel-sidebar .panel-body');

                        let messageBlock = $('<div>', {
                            class: 'text-center',
                        });

                        $('<div>', {
                            class: 'alert alert-danger',
                            text: errorMessage,
                        }).css('white-space', 'normal').appendTo(messageBlock);

                        $('<button>', {
                            class: 'btn btn-responsive text-pink',
                            text: 'ATUALIZAR'
                        }).click(function() {
                            location.reload();
                        }).appendTo(messageBlock);

                        target.html(messageBlock);

                    } else {
                        let errorMessage = "Ocorreu um problema na autorização de sua contribuição. Por favor, tente novamente.";
                        if (json.message) {
                            if (typeof json.message !== "object") {
                                json.message = JSON.parse(json.message);
                            }
                            if (json.message.errors) {
                                let errors = json.message.errors;
                                errorMessage = "<ul>";
                                errors.forEach(error => {
                                    errorMessage += `<li><strong>${error.message}</strong></li>`;
                                });
                                errorMessage += "</ul>";
                            }
                        }
                        const msg = $('#divMensagemErro');
                        msg.html(errorMessage);
                        $('#divMensagemAviso').hide();
                        $('#divMensagemInfo').hide();
                        msg.show();
                        $('#btnVoltar').prop('disabled', false);
                        $('#btnPagar').prop('disabled', false);
                    }
                }

                paymentForm.isPaying = false;
            },
            error: function (jqXHR, textStatus, errorThrown) {
                paymentForm.isPaying = false;

                clearTimeout(paymentForm.oTime);
                switch (textStatus) {
                    case 'timeout':
                        $('#divLoadingEmail').hide();
                        $('#divMensagemErro').html('TEMPO EXCEDIDO AO CONECTAR COM O GATEWAY DE PAGAMENTO. A mensagem informada foi: ' + errorThrown + '<br/>Por favor, tente novamente.');
                        $('#divMensagemAviso').hide();
                        $('#divMensagemInfo').hide();
                        $('#divMensagemErro').show();
                        break;

                    default:
                        $('#divLoadingEmail').hide();
                        $('#divMensagemErro').html('OCORREU UM ERRO. A mensagem informada foi: ' + errorThrown + '<br/>Por favor, tente novamente.');
                        $('#divMensagemAviso').hide();
                        $('#divMensagemInfo').hide();
                        $('#divMensagemErro').show();
                        break;
                }
                $('#btnVoltar').prop('disabled', false);
                $('#btnPagar').prop('disabled', false);
                return false;
            }
        });
    }, //end of ajaxMagic

    moipSucesso: function (data) {
        const instituicao = $('#bandeira').val();
        let numero = $('#cc_numero').val();
        numero = numero.substring(numero.length - 4);
        const expiracao = $('#cc_validade').val();
        const codigo_seguranca = $('#cc_codigo_seguranca').val();
        const nome = $('#cc_nome_impresso').val();

        $.ajax({
            type: 'POST',
            url: App.webRoot + 'projeto/salvaRetornoMoip',
            data: {
                dados_pgto: 'cartao: ' + numero + ' | bandeira: ' + instituicao + ' | expiracao: ' + expiracao + ' | cod: ' + codigo_seguranca + ' | nome: ' + nome,
                tipo: 'ok',
                id_contribuicao: ProjectPage.contribution_id,
                retorno_moip: JSON.stringify(data)
            },
            dataType: 'json',
            cache: false,
            timeout: 40000,
            success: function (json) {
            },
            error: function (json) {
            },
        });

        if (data.Status === 'Cancelado') {
            // ocorreu algum erro
            var sMensagem = '';
            if ((data.Mensagem) && (data.Mensagem !== 'undefined') && (data.Mensagem !== undefined)) {
                if (data.hasOwnProperty('Classificacao')) {
                    sMensagem = data.Classificacao.Descricao;
                    if (sMensagem === 'Politica do banco emissor') {
                        sMensagem = 'Por favor, revise os dados do cartão e tente novamente.';
                    }
                } else {
                    if (data.Mensagem === 'Requisição processada com sucesso') {
                        sMensagem = 'Por favor, revise os dados do cartão e tente novamente.';
                    } else sMensagem = data.Mensagem;

                }
            } else {
                sMensagem = 'Por favor, revise os dados do cartão e tente novamente.';
            }

            $('#divMensagemAviso').hide();
            $('#divMensagemInfo').hide();
            $('#divMensagemErro').show();
            Utils.goToSidebarTop();
            $('#btnVoltar').prop('disabled', false);
            $('#btnPagar').unbind('click');
            $('#btnPagar').html('Revisar contribuição');
            $('#btnPagar').removeClass('js-evbind-GoPaymentGatewayCC');
            $("#btnPagar").detach().appendTo('#destinationAfterFailure');
            $('#btnPagar').click(function (e) {
                e.preventDefault(e);
                paymentForm.isEditingAFailedColaboration = true;
                Utils.goToSidebarTop();
                // window.location.reload();
                var url = App.webRoot + 'projeto/ajaxContribuicaoRevisao/' + ProjectPage.project_id + '-' + ProjectPage.contribution_id + '-' + paymentForm.isEditingAFailedColaboration;
                App.loadContentViaAjax(url, {}, '.panel-sidebar .panel-body');
            });
            $('#btnPagar').prop('disabled', false);
        } else {
            Utils.goToSidebarTop();
            var url = App.webRoot + 'projeto/ajaxContribuicaoP4/' + ProjectPage.project_id + '-'
                + ProjectPage.contribution_id + '-' + encodeURIComponent(data.Status)
                + '-' + data.CodigoMoIP + '-' + encodeURIComponent(data.StatusPagamento) + '-' + data.Codigo;
            App.loadContentViaAjax(url, {}, '.panel-sidebar .panel-body');
            $('html, body').animate({
                scrollTop: $(".panel-sidebar").offset().top - 120
            }, 2000);
        }
    }, //end of moipSucesso()

    moipFalha: function (data) {
        var instituicao = $('#bandeira').val();
        var numero = $('#cc_numero').val();
        numero = numero.substring(numero.length - 4);
        var expiracao = $('#cc_validade').val();
        var codigo_seguranca = $('#cc_codigo_seguranca').val();
        var nome = $('#cc_nome_impresso').val();
        $.ajax({
            type: 'POST',
            url: App.webRoot + 'projeto/salvaRetornoMoip',
            data: {
                dados_pgto: 'cartao: ' + numero + ' | bandeira: ' + instituicao + ' | expiracao: ' + expiracao + ' | cod: ' + codigo_seguranca + ' | nome: ' + nome,
                tipo: 'erro',
                id_contribuicao: ProjectPage.contribution_id,
                retorno_moip: JSON.stringify(data)
            },
            dataType: 'json',
            cache: false,
            timeout: 40000,
            success: function (json) {
            },
            error: function (json) {
            },
        });

        if ((data.Mensagem) && (data.Mensagem !== 'undefined') && (data.Mensagem !== undefined)) {
            $('#divMensagemErro').html('<strong>Ops... Ocorreu um problema.</strong><br/>' + data.Mensagem);
        }

        $('#divMensagemAviso').hide();
        $('#divMensagemInfo').hide();
        $('#divMensagemErro').show();

        Utils.goToSidebarTop();
        $('#btnPagar').unbind('click');
        $('#btnPagar').html('Revisar contribuição');
        $('#btnPagar').removeClass('js-evbind-GoPaymentGatewayCC');
        $("#btnPagar").detach().appendTo('#destinationAfterFailure');
        $('#btnPagar').click(function (e) {
            e.preventDefault();
            paymentForm.isEditingAFailedColaboration = true;
            Utils.goToSidebarTop();
            var url = App.webRoot + 'projeto/ajaxContribuicaoRevisao/' + ProjectPage.project_id + '-' + ProjectPage.contribution_id + '-' + paymentForm.isEditingAFailedColaboration;
            App.loadContentViaAjax(url, {}, '.panel-sidebar .panel-body');
        });
        $('#btnPagar').prop('disabled', false);
    }, //end of moipFalha()

    pagarPaypal: function () {
        ProjectPage.goToNext();
        $('.panel-sidebar').load(App.webRoot + 'projeto/ajaxContribuicaoP3/' + ProjectPage.project_id + '-'
            + ProjectPage.contribution_id + '-paypal', function () {
            $('html, body').animate({
                scrollTop: $(".panel-sidebar").offset().top - 120
            }, 2000);
        });
    }, //end of pagarPaypal()

    pagarBoleto: function () {
        var settings = {
            "Forma": "BoletoBancario"
        };
        MoipWidget(settings);
    }, //end of pagarBoleto()
};